/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../resources/enums';
import '../../resources/error';
import '../resources/datatypes';
import './interfaces-common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "BatchRetrieveCatalogObjectsRequest": {
                        "fields": {
                          "objectIds": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "includeRelatedObjects": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includeCounts": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "catalogVersion": {
                            "type": "int64",
                            "id": 6,
                            "rule": "optional"
                          },
                          "includeDeletedObjects": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includeNestedObjects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.InlineTypes",
                            "id": 8,
                            "rule": "optional",
                            "options": {
                              "default": "INLINE_ALL"
                            }
                          },
                          "includeCategoryPathToRoot": {
                            "type": "bool",
                            "id": 9,
                            "rule": "optional"
                          },
                          "includeCategoryEnablementsForCombos": {
                            "type": "bool",
                            "id": 10,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "includeInventory": {
                            "type": "bool",
                            "id": 11,
                            "rule": "optional",
                            "options": {
                              "default": true
                            }
                          }
                        }
                      },
                      "BatchRetrieveCatalogObjectsResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "objects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "relatedObjects": {
                            "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogObject",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "categoryEnablementsForCombos": {
                            "type": ".squareup.connect.v2.merchant_catalog.service.CategoryEnablementForCombos",
                            "id": 4,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.BatchRetrieveCatalogObjectsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.BatchRetrieveCatalogObjectsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BatchRetrieveCatalogObjectsRequest @ squareup/connect/v2/catalog/interfaces/batch-retrieve-catalog-obj.proto at 21:1
 */
export const BatchRetrieveCatalogObjectsRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.BatchRetrieveCatalogObjectsRequest');
fixType(BatchRetrieveCatalogObjectsRequest, {
  objectIds: {
    required: true,
    notEmpty: true
  }
});
Builder.createAndAttachToType(BatchRetrieveCatalogObjectsRequest);
/**
 * SOURCE BatchRetrieveCatalogObjectsResponse @ squareup/connect/v2/catalog/interfaces/batch-retrieve-catalog-obj.proto at 117:1
 */
export const BatchRetrieveCatalogObjectsResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.BatchRetrieveCatalogObjectsResponse');
fixType(BatchRetrieveCatalogObjectsResponse);
Builder.createAndAttachToType(BatchRetrieveCatalogObjectsResponse);